export enum PaymentMethod {
    DirectDebit = 1,
    Card
}
